// extracted by mini-css-extract-plugin
module.exports = {"total-cost":"total-cost__2XDQt"};